import './Footer.css'

export default {
	name: "eiis-footer",
  props: {
    appName: String, version: String, text: String,
    includeCopyright: Boolean, 
    includeTerms: Boolean, 
    includePrivacy: Boolean, 
    includeCredits: Boolean, 
    fixedBottom: Boolean, 
  },
  template: `
    <div class="eiis-footer" :class="{ fixedBottom: fixedBottom }">
      <div class="eiis-footer-content container">
        <div>
          {{text}}
        </div>
        <div v-if=includeCopyright>
          Copyright 2021 {{appName}}
        </div>
        <div>
          Version {{version}}
        </div>
        <div v-if=includeTerms>
          <a href="/tos">Terms of Service</a>
        </div>
        <div v-if=includePrivacy>
          <a href="/privacy">Privacy Policy</a>
        </div>
        <div v-if=includeCredits>
          <a href="/credits">Credits</a>
        </div>
      </div>
    </div>
  `
}